import React, {useEffect, useState} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

export default function Loading() {
    const [opacity, setOpacity] = useState(0)
        
    useEffect(() => {
        setTimeout(() => {
            setOpacity(1)
        }, 500)
    }, [])
        
    return (
        <Backdrop
            sx={{ opacity: opacity + '!important', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
        >
            <CircularProgress size={96} sx={{ margin: 'auto', color: '#fff' }} />
        </Backdrop>
    );
}